<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>編輯桌號</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="uploadTableNumbers">上傳</f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div v-if="isTableNumberDirty" class="warning">請按上傳完成變更</div>

    <f7-list>
      <f7-list-item ref="new">
        <f7-label>新增桌號</f7-label>
        <f7-input
          type="text"
          placeholder="ex. A3"
          :value="newTableNumber"
          @input="newTableNumber = $event.target.value"
          @focus="onFocus('new')"
          clear-button/>
        <f7-button fill raised style="margin: 20px; width: 50px;" @click="setTableNumbersOnClick" slot="content">新增</f7-button>
      </f7-list-item>
    </f7-list>
    <f7-list sortable :sortable-enabled="true" @sortable:sort="updateTableNumberOrder({ from: $event.detail.from, to: $event.detail.to })">
      <f7-list-item
        v-for="(tableNumber, index) in tableNumbers"
        :key="`store-info-settings-table-numbers-${index}`"
        :title="tableNumber"
        style="margin-left: 20px;">
        <font-awesome-icon icon="trash" slot="content-start" @click="deleteTableNumber(index)" style="color: red; margin-right: 10px;" />
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      newTableNumber: ''
    }
  },
  async created () {
    await this.setStore(this.storeIdProp)
    this.getTableNumbers()
  },
  computed: {
    ...mapState(['tableNumbers', 'isTableNumberDirty'])
  },
  methods: {
    deleteTableNumber (index) {
      this.setTableNumbers(this.tableNumbers.slice(0, index).concat(this.tableNumbers.slice(index + 1, this.tableNumbers.length)))
    },
    setTableNumbersOnClick () {
      this.setTableNumbers(this.tableNumbers.concat([this.newTableNumber]))
      this.newTableNumber = ''
    },
    updateTableNumberOrder ({ from, to }) {
      const tableNumbers = this.tableNumbers.slice()
      tableNumbers.splice(to, 0, tableNumbers.splice(from, 1)[0])
      this.setTableNumbers(tableNumbers)
    },
    ...mapActions(['setStore', 'setTableNumbers', 'getTableNumbers']),
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    uploadTableNumbers () {
      storeClient.put(`/stores/${this.storeIdProp}/tableNumbers`, { tableNumbers: this.tableNumbers })
    }
  },
  props: {
    storeIdProp: String
  }
}
</script>

<style lang="scss" scoped>
.warning {
  color: #856404;
  background-color: #FFF3CD;
  border: solid 1px #FFEEBA;
  border-radius: 5px;
  width: 90%;
  margin: 20px auto;
  padding: 10px 20px;
  box-shadow: 2px 2px 2px #EEEEEE;
  box-sizing: border-box;
}
</style>
